import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import moment from 'moment';
import 'moment/locale/es';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';

moment.locale('es');

if (environment.production) {
  enableProdMode();

  // Deshabilitar toda salida de consola en producción
  const noop = (): void => {};
  const consoleMethods = ['log', 'debug', 'info', 'warn', 'error', 'trace', 'table', 'dir', 'group', 'groupCollapsed', 'groupEnd'] as const;
  consoleMethods.forEach((method) => {
    if (typeof (window.console as unknown as Record<string, unknown>)[method] === 'function') {
      (window.console as unknown as Record<string, () => void>)[method] = noop;
    }
  });
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
